<template lang="pug">
transition( name='fade' mode='out-in' appear )
  .modal( 
    v-show='currentModal'
    :class='[{ fullscreen, filled, bg, centered }, `${name}-outer`]'
  )
    component(
      :is='name'
      v-bind='modalData'
      :meta=`{ name, modalId, currentModal, fullscreen, filled, bg, centered }`
    )
</template>

<script lang="js">
import { mapState } from 'vuex'
import { modals, components as modalComponents } from '@/modals'
import { Logger } from '@/lib/logger'

export default {
  name: 'modal',
  mixins: [],
  components: { ...modalComponents },
  props: {},
  data() {
    return {
      modals
    }
  },
  created() {
    Logger.debug( 'modal components', '<modal>', modalComponents )()
  },
  mounted() {},
  methods: {},
  provide: {
    inModal: true
  },
  computed: {
    ...mapState([ 'currentModal' ]),
    name() {
      return ( this.currentModal && this.currentModal.name ) || 'div'
    },
    modalData() {
      return ( this.currentModal && this.currentModal.data ) || {}
    },
    modalId() {
      return ( this.modalData && this.modalData.id ) || ''
    },
    fullscreen() {
      return this.modals[ this.name ] &&
         this.modals[ this.name ].meta.fullscreen
    },
    filled() {
      return this.modals[ this.name ] &&
         this.modals[ this.name ].meta.filled
    },
    bg() {
      return this.modals[ this.name ] &&
         this.modals[ this.name ].meta.bg
    },
    centered() {
      return this.modals[ this.name ] &&
         this.modals[ this.name ].meta.centered
    }
  }
}
</script>

<style lang="scss">
.modal {
  background: var(--bg-modal, var(--bg-dark, black));
  position: fixed;
  display: block;
  top: 50%;
  left: 50%;
  right: unset;
  bottom: unset;
  height: var(--h-modal, 50%);
  width: var(--w-modal, 50%);
  min-height: var(--h-min-modal, 250px);
  min-width: var(--w-min-modal, 400px);
  transform: translate(-50%, -50%);
  z-index: 11;
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
  &.fullscreen {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transform: none;
  }
  &.bg {
    background: black;
    background: radial-gradient(ellipse at bottom right, rgba(0,28,84,1) 0%, rgba(0,0,0,1) 100%);
  }
  &.centered {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
